<p>
    Your well has intersected wells within a 50" buffer zone. It is possible that this well could intersect
    an existing well due to potential inaccuracy in data.
</p>
